import { Text, View } from "react-native";
import { AppFontStyle } from "../styles/AppFontStyle";
import { AppColors } from "../utility/AppColors";
import React from "react";

export const CommonTag = (props: any) => {
  const { title = "", tagStyle } = props;

  return (
    <View style={tagStyle}>
      <Text
        style={[
          AppFontStyle.REGULAR_ANYBODY_12,
          {
            color: AppColors.white,
            paddingHorizontal: 9,
            paddingVertical: 3,
          },
        ]}
      >
        {title}
      </Text>
    </View>
  );
};
